import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, Label, Input, Button} from "reactstrap";
import './InquiryForm.scss'
import IntlTelInput from "react-intl-tel-input";
import {mobileNumberInputValidation} from "../../utils/validator";
import "../../../node_modules/react-intl-tel-input/dist/main.css";
import * as commonFunc from "../../utils/commonFunc";
import axios from "axios";


class HowItsWork extends Component {

    state = {
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        mobileNumberEnter: '',
        country: 'lk',
        message:''
    };

    onPhoneNumberChange = (condition, value, object, withdialcode) => {
        if (mobileNumberInputValidation(value, withdialcode, condition).numberInputValidation) {
            this.setState({
                isValidMob: mobileNumberInputValidation(value, withdialcode, condition).mobileNumberValidation,
                mobileNumber: withdialcode,
                mobileNumberEnter: value
            });
        }
    };

    textOnChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({[name]: value});
    };

    formSubmitHandler = () => {
        let emailReg = new RegExp("^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$");
        const obj = {
            First_Name: this.state.firstName,
            Last_Name: this.state.lastName,
            Email: this.state.email,
            Mobile_Number: this.state.mobileNumber,
            Message: this.state.message
        };
        if (this.state.firstName.trim() === "" || this.state.lastName.trim() === "" || this.state.email.trim() === "" || this.state.mobileNumber.trim() === "" || this.state.message.trim() === "") {
            commonFunc.notifyMessage("Please fill all the fields!", 0);
            return;
        } else if (!emailReg.test(this.state.email)){
            commonFunc.notifyMessage("Invalid Email Address: Please enter a valid email address.",0);
            return;
        } else {
            axios.post("https://formcarry.com/s/d4iemeDUlsu", obj, {headers: {Accept: "application/json"}})
                .then(() => {
                    this.setState({firstName: "",lastName: "",email: "",mobileNumber: "", mobileNumberEnter: "", message: ""});
                    commonFunc.notifyMessage("Your form submitted successfully!",1);
                })
                .catch((error) => {
                    console.log(error);
                    commonFunc.notifyMessage("Your form submission failed",0);
                });
        }
    }

    render() {
        let {desc,descSin} = this.props;
        let {firstName,lastName,email,country,mobileNumberEnter,mobileNumber,message} = this.state;
        return (
            <div id={'inquiryForm'} className="container inquiryForm pt-5 pb-6 ">
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className='text-center'>
                            <h1 className='main-topic'>
                                Let us know what you think
                            </h1>
                            <p className='py-4 inquiry-para mb-0'>{desc}</p>
                            {descSin && <p className='py-4 inquiry-para'>{descSin}</p>}
                        </div>
                    </Col>
                </Row>
                <form>

                <Row className='inquiryForm-wrapper'>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <div>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="exampleEmail">
                                            First Name
                                        </Label>
                                        <Input
                                            value={firstName}
                                            name="firstName"
                                            placeholder=" First Name"
                                            type="text"
                                            onChange={this.textOnChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="examplePassword">
                                            Last Name
                                        </Label>
                                        <Input
                                            value={lastName}
                                            name="lastName"
                                            placeholder="Last Name"
                                            type="text"
                                            onChange={this.textOnChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup>
                                <Label for="exampleAddress">
                                    Email
                                </Label>
                                <Input
                                    value={email}
                                    name="email"
                                    type={"email"}
                                    placeholder="you@education.com"
                                    onChange={this.textOnChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>
                                    Phone Number
                                </Label>
                               <div>
                                   <IntlTelInput
                                       name='mobile'
                                       defaultCountry={country}
                                       preferredCountries={['lk']}
                                       inputClassName="form-control auth-input w-100"
                                       containerClassName="intl-tel-input w-100"
                                       customPlaceholder={'XXXXXXXXXX'}
                                       onPhoneNumberChange={this.onPhoneNumberChange}
                                       value={mobileNumberEnter}
                                   />
                               </div>
                            </FormGroup>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label>
                                            Message
                                        </Label>
                                        <Input
                                            name="message"
                                            type="textarea"
                                            value={message} onChange={this.textOnChange}
                                        />
                                    </FormGroup>
                                </Col>

                            </Row>
                            {/*<FormGroup className='checkbox-field' check>*/}
                            {/*    <Input*/}
                            {/*        name="check"*/}
                            {/*        type="checkbox"*/}
                            {/*    />*/}
                            {/*    <Label*/}
                            {/*      className='pl-4 pb-0'  check*/}
                            {/*    >*/}
                            {/*        You agree to our friendly privacy policy.*/}
                            {/*    </Label>*/}
                            {/*</FormGroup>*/}
                            <Button className='btn-sendMessage my-4 w-100' onClick={this.formSubmitHandler}>
                                Send Message
                            </Button>
                        </div>
                    </Col>
                </Row>
                </form>
            </div>
        )
    }
}

export default HowItsWork;
